import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Button from "../Button";
import { post, normalPost } from "../../lib/Fetching";
import { DefaultPaddedContainerNoShadow } from "./Theme";
import { notifyDialog } from "../../lib/Dialog";

const Container = styled.div``;

export default function ExportSamples({ sampleIds, clientView }) {
  const [hideUnits, setHideUnits] = useState(false);
  const [version, setVersion] = useState("");
  const [succeedsVersion, setSucceedsVersion] = useState("");

  const _baseUrl = () => {
    return window.location.protocol + "//" + window.location.host;
  };

  const exportUrl = _baseUrl() + "/lims_sample_reporting/exports";

  const notify = (response) => {
    notifyDialog("File Is Generating", response.success, () => {});
  };

  const wrapPost = (url, params) => {
    const sampleCount = params["sample_ids"].length;
    // if (sampleCount > 1500) {
    //   alert(
    //     "You cannot export more than 1500 samples at once. You selected " +
    //       sampleCount +
    //       " samples."
    //   );
    //   return Promise.reject();
    // }
    return post(url, params);
  };

  const standardSampleColumnsExport = () => {
    wrapPost(exportUrl, {
      type: "standard_sample_columns_export",
      sample_ids: sampleIds,
      format: "xlsx",
      hide_units: hideUnits,
    }).then(notify);
  };

  const exportColumnFormat = () => {
    wrapPost(exportUrl, {
      type: "all_results_columns",
      sample_ids: sampleIds,
      format: "xlsx",
      hide_units: hideUnits,
    }).then(notify);
  };

  const nutritionExport = () => {
    wrapPost(exportUrl, {
      type: "nutrition_export",
      sample_ids: sampleIds,
    }).then(notify);
  };

  const corityExport = () => {
    wrapPost(exportUrl, {
      type: "cority",
      sample_ids: sampleIds,
    }).then(notify);
  };

  const positivesExportColumnFormat = () => {
    wrapPost(exportUrl, {
      type: "detected_results_columns",
      sample_ids: sampleIds,
      format: "xlsx",
      hide_units: hideUnits,
    }).then(notify);
  };

  const mrlExportColumnFormat = () => {
    wrapPost(exportUrl, {
      type: "all_results_mrl_columns",
      sample_ids: sampleIds,
      format: "xlsx",
      hide_units: hideUnits,
    }).then(notify);
  };

  const mrlExportColumnFormatInRows = () => {
    wrapPost(exportUrl, {
      type: "row_based_mrl_report",
      sample_ids: sampleIds,
      format: "xlsx",
      hide_units: hideUnits,
    }).then(notify);
  };

  const foodForensicsExportFormat = () => {
    wrapPost(exportUrl, {
      type: "food_forensics",
      sample_ids: sampleIds,
      format: "xlsx",
      hide_units: hideUnits,
    }).then(notify);
  };

  const aisBasicExportFormat = () => {
    wrapPost(exportUrl, {
      type: "ais_basic",
      sample_ids: sampleIds,
    }).then(notify);
  };
  
  const rsslExport = () => {
    wrapPost(exportUrl, {
      type: "rssl_export",
      sample_ids: sampleIds,
    }).then(notify);
  };

  const exportSimplifiedReport = () => {
    const url = _baseUrl() + "/lims_sample_reporting/simplified_reports";
    wrapPost(url, { sample_ids: sampleIds }).then(notify);
  };

  const printSampleListPDF = () => {
    const url = _baseUrl() + "/sample_reporting/sample_lists/create";
    normalPost(url, { sample_ids: sampleIds });
  };

  const printSampleListPDFwithTesting = () => {
    const url = _baseUrl() + "/sample_reporting/sample_lists/create";
    normalPost(url, { sample_ids: sampleIds, show_testing: true });
  };

  const exportSimplifiedJobReport = () => {
    const url = _baseUrl() + "/lims_sample_reporting/reports.json";
    normalPost(url, { 
      sample_ids: sampleIds, 
      type: "simplified_job_report" ,
      version: version,
      succeeds_version: succeedsVersion
    }).then(notify);
  };

  const exportDioxinsReport = () => {
    const url = _baseUrl() + "/lims_sample_reporting/reports.json";
    normalPost(url, { sample_ids: sampleIds, type: "dioxin_report" }).then(notify);
  };

  const disabled = sampleIds.length == 0;
  return (
    <DefaultPaddedContainerNoShadow
      style={{ marginTop: 10, border: 0, textAlign: "left", fontSize: "10pt" }}
    >
      <p>{I18n.t("all_generated_files")}</p>
      <div style={{ marginBottom: 0 }}>
        <p style={{ marginBottom: 10 }}>{I18n.t("export.excel_reports")}</p>
        <Button
          icon="fa-download"
          disabled={disabled}
          onClick={exportColumnFormat}
          tiny
          title={I18n.t("export.all_available")}
          style={{ marginRight: 10 }}
        />
        <Button
          icon="fa-download"
          disabled={disabled}
          onClick={positivesExportColumnFormat}
          tiny
          title={I18n.t("export.detected_results")}
          style={{ marginRight: 10 }}
        />
        <Button
          icon="fa-download"
          disabled={disabled}
          onClick={mrlExportColumnFormat}
          tiny
          title={I18n.t("export.all_available_with_mrl")}
          style={{ marginRight: 10 }}
        />
        <Button
          icon="fa-download"
          disabled={disabled}
          onClick={mrlExportColumnFormatInRows}
          tiny
          title={I18n.t("export.all_available_with_mrl_in_rows")}
          style={{ marginRight: 10 }}
        />
        <Button
          icon="fa-download"
          disabled={disabled}
          onClick={foodForensicsExportFormat}
          tiny
          title={I18n.t("export.food_forensics_report")}
          style={{ marginRight: 10 }}
        />
        <Button
          icon="fa-download"
          disabled={disabled}
          onClick={standardSampleColumnsExport}
          tiny
          title={I18n.t("export.standard_sample_columns")}
          style={{ marginRight: 10 }}
        />
        {!clientView && (
          <Button
            icon="fa-download"
            disabled={disabled}
            onClick={nutritionExport}
            tiny
            title="Nutrition Export"
            simplified_job_report
            style={{ marginRight: 10 }}
          />
        )}
        {!clientView && (
          <Button
            icon="fa-download"
            disabled={disabled}
            onClick={aisBasicExportFormat}
            tiny
            title="AIS Basic"
            simplified_job_report
            style={{ marginRight: 10 }}
          />
        )}
        {!clientView && (
          <Button
            icon="fa-download"
            disabled={disabled}
            onClick={rsslExport}
            tiny
            title="RS Export"
            simplified_job_report
            style={{ marginRight: 10 }}
          />
        )}
        <Button
          icon="fa-download"
          disabled={disabled}
          onClick={corityExport}
          tiny
          title="Cority"
          simplified_job_report
          style={{ marginRight: 10 }}
        />
        <br />
        <label style={{ marginTop: 5 }}>
          <input
            type="checkbox"
            checked={hideUnits}
            onChange={() => setHideUnits(!hideUnits)}
          />
          &nbsp; Hide units in Excel file?
        </label>
        <p style={{ marginBottom: 10, marginTop: 10 }}>{I18n.t("export.pdf_reports")}</p>
        <Button
          icon="fa-download"
          disabled={disabled}
          onClick={exportSimplifiedReport}
          tiny
          title={I18n.t("export.simplified_pdf_report")}
          style={{ marginRight: 10 }}
        />
        <Button
          icon="fa-download"
          disabled={disabled}
          onClick={printSampleListPDF}
          tiny
          title={I18n.t("export.sample_list_pdf")}
          style={{ marginRight: 10 }}
        />
        <Button
          icon="fa-download"
          disabled={disabled}
          onClick={printSampleListPDFwithTesting}
          tiny
          title={I18n.t("export.sample_list_with_testing_pdf")}
          style={{ marginRight: 10 }}
        />
        {!clientView && (
          <Button
            icon="fa-download"
            disabled={disabled}
            onClick={exportDioxinsReport}
            tiny
            title={I18n.t("export.dioxin_report")}
            style={{ marginRight: 10 }}
          />
        )}
        <br/>
        <br/>
        <Button
          icon="fa-download"
          disabled={disabled}
          onClick={exportSimplifiedJobReport}
          tiny
          title={I18n.t("export.simplified_job_report")}
          style={{ marginRight: 10 }}
        />
        {!clientView && (
          <span>
            <input type="text" value={version} onChange={(e) => setVersion(e.target.value)} placeholder="Version" style={{ width: "60px", marginLeft: -10 }} />
            <input type="text" value={succeedsVersion} onChange={(e) => setSucceedsVersion(e.target.value)} placeholder="Succeeds Version" style={{ width: "110px" }} />
          </span>
        )}
      </div>
    </DefaultPaddedContainerNoShadow>
  );
}
